import {
  resolveThoughtActivityKind,
  thoughtActivityBody,
  thoughtActivityCopy,
} from './thoughtActivityKinds'

export function publicTimelinePhaseCopy(phase) {
  const kind = resolveThoughtActivityKind({
    category: phase.category,
    phaseId: phase.id,
    title: phase.title,
  })
  const copy = thoughtActivityCopy(kind)
  return { kind, title: copy.title, body: thoughtActivityBody(phase.body, kind) }
}
